export default [
  {
    value: 'id',
    text: 'ID',
    width: 60,
    type: 'number',
    description: ''
  },
  {
    value: 'kioskName',
    text: 'Имя',
    type: 'string',
    description: ''
  },
  {
    value: 'isActive',
    text: 'Активен',
    width: 80,
    type: 'boolean',
    sortable: false,
    description: ''
  },
  {
    value: 'isOnline',
    text: 'Онлайн',
    width: 80,
    type: 'boolean',
    sortable: false,
    description: ''
  },
  {
    value: 'lastReported',
    text: 'Был на связи',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'serialNumber',
    text: 'Серийный номер',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'type',
    text: 'Тип',
    width: 160,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'city.title',
    text: 'Город',
    width: 160,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    align: 'end',
    width: 105,
    type: 'actions',
    sortable: false,
    description: ''
  }
]
